var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollercoaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.67433 0.974121C10.4734 0.974121 12.7561 3.14836 12.8714 5.87314L12.8759 6.08937V10.2749C12.8759 11.184 13.5858 11.93 14.4902 12.0059L14.6427 12.0123V16.0262C11.4878 16.0262 8.9164 13.5696 8.79851 10.4955L8.79429 10.2749V6.08937C8.79429 5.48111 8.29286 4.98801 7.67433 4.98801C7.09703 4.98801 6.62176 5.41755 6.56095 5.96937L6.55437 6.08937V9.93162C6.55437 13.2211 3.90438 15.9018 0.589274 16.022L0.356934 16.0262V12.0123C1.47466 12.0123 2.38996 11.16 2.46743 10.0802L2.47275 9.93162V6.08937C2.47275 3.2643 4.80157 0.974121 7.67433 0.974121Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollercoaster);
export default __webpack_public_path__ + "static/media/Rollercoaster.2924f3fcccd83d7878222b34a37f01ab.svg";
export { ForwardRef as ReactComponent };